import { createI18n } from 'vue3-i18n'
import locales from '@/locales/locales'

const i18n = createI18n({
  locale: localStorage.getItem('lang_gmbt') || 'en',
  messages: locales,
})

export default i18n
